import { type CanvasElement } from '@blaze-runtime/engine-domain';
import { type LayoutReferenceInfo, type PageInfo } from '@blaze-shared/api-contracts-domain';

import { type GetPropsExtractorFn } from '../../../services/element-definitions.service';

import { getElementPropsExtractor } from './get-element-props-extractor';

export function getLayoutPagesReferences(
  pageId: string,
  elements: CanvasElement[],
  projectPages: PageInfo[] | null,
  getPropsExtractor: GetPropsExtractorFn | null,
): LayoutReferenceInfo[] | undefined {
  if (projectPages === null || getPropsExtractor == null) {
    return undefined;
  }

  // to check whether referenced page exists
  const pagesMap = projectPages.reduce(
    (result, { id }) => {
      result[id] = true;
      return result;
    },
    {} as Record<string, boolean>,
  );

  const updated: LayoutReferenceInfo[] = [];
  for (const element of elements) {
    try {
      const extractor = getElementPropsExtractor(element, getPropsExtractor);
      const rawRefs = extractor?.getPageReferences();
      const refsIds = rawRefs?.filter((pid) => pid !== pageId && pagesMap[pid]); // ensure page exists
      const refs = refsIds?.map<LayoutReferenceInfo>((pageId) => ({
        pageId,
        sourceElementId: element.id,
        sourceElementType: element.type,
      }));
      if (refs?.length) {
        updated.push(...refs);
      }
    } catch (error) {
      console.log(`Error gathering page refs for ${element.id}:`, error);
    }
  }

  return updated;
}
